module.exports = "/_next/static/images/PrivacyPortal@3x-3cdab5ee75371502b50936e9f1a1d7a3.webp";